import { supabase } from '@/src/core/config/supabase';
import { ModerationFieldType } from '@/src/domain/models/Moderation';
import { logger } from '@/src/core/utils';

export interface ModerationResponse {
  action: 'allow' | 'flag' | 'block';
  reasons: string[];
}

export class ModerationDataSource {
  async moderate(params: {
    text?: string;
    imageUrl?: string;
    fieldType: ModerationFieldType;
    userId: string;
  }): Promise<ModerationResponse> {
    const { data, error } = await supabase.functions.invoke('moderate-content', {
      body: {
        text: params.text,
        imageUrl: params.imageUrl,
        fieldType: params.fieldType,
        userId: params.userId,
      },
    });

    if (error) {
      // Log the full error context for debugging
      logger.error('ModerationDataSource', 'Edge Function error', {
        error,
        errorMessage: error.message,
        responseData: data,
        fieldType: params.fieldType,
      });
      throw new Error(`Moderation failed: ${error.message}`);
    }

    return {
      action: data.action,
      reasons: data.reasons || [],
    };
  }
}
